import { CSSProperties, forwardRef } from 'react';
import { StyledVideoPreview } from './styled';

type Props = {
  id?: string;
  mirrored?: boolean;
  className?: string;
  objectFit?: CSSProperties['objectFit'];
  children?: React.ReactNode;
}

const VideoPreview = forwardRef<HTMLDivElement, Props>((
  {
    id,
    mirrored,
    objectFit = 'contain',
    children,
    className
  },
  ref,
) => (
  <StyledVideoPreview
    id={id}
    $mirrored={mirrored}
    $objectFit={objectFit}
    ref={ref}
    className={className}
  >
    {children}
  </StyledVideoPreview>
));

export default VideoPreview;